const state = {
  type: null,
  message: null
};

const actions = {
  success({ commit }, message) {
    this._vm.$vs.notify({
      title: 'Sucesso!',
      text: message,
      color: 'success'
    })
    commit("success", message);
  },
  error({ commit }, message) {
    console.log(message)

    this._vm.$vs.notify({
      title: 'Erro!',
      text: message,
      color: 'danger',
      position: 'top-center'  
    })
    commit("error", message);
  },
  clear({ commit }, message) {
    commit("success", message);
  }
};

const mutations = {
  success(state, message) {
    state.type = "alert-success";
    state.message = message;
  },
  error(state, message) {
    state.type = "alert-danger";
    state.message = message;
  },
  clear(state) {
    state.type = null;
    state.message = null;
  }
};

export const alert = {
  namespaced: true,
  state,
  actions,
  mutations
};
